import {
  actionTypes,
  sendCsvActionFailure,
  sendCsvActionSuccess,
} from "./actions";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { sendCsvRequestService } from "./services";

const sendCsvEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SEND_CSV_REQUEST),
    mergeMap((action: any) =>
      sendCsvRequestService(action.payload).pipe(
        map((response: any) => sendCsvActionSuccess(response)),
        catchError((error: any) => of(sendCsvActionFailure(error)))
      )
    )
  );

export default [sendCsvEpic];
